// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { logError } from "../components/Errors";
import { getUser, getClient } from "./session";
import { refreshAccessToken } from "./refreshTokens";

function toFormData(body = {}) {
  return Object.keys(body).reduce((formData, key) => {
    const item = body[key];
    if (Array.isArray(item)) {
      body[key] && formData.append(key, JSON.stringify(item));
    } else if (typeof item === "object") {
      body[key] && formData.append(key, JSON.stringify(item));
    } else if (typeof item === "boolean") {
      formData.append(key, item ? "true" : "false");
    } else {
      body[key] && formData.append(key, body[key]);
    }
    return formData;
  }, new FormData());
}

export async function fetchRequest(
  { method = "GET", path, body = undefined, options = {} } = { body: any },
) {
  const { token, headers, ...overrides } = options;

  const requestHeaders = {
    Accept: "application/json",
    ...headers,
  };

  if (token && typeof token === "string" && token.length > 0) {
    const { accessToken } = await refreshAccessToken(token);
    requestHeaders["Authorization"] = `Bearer ${accessToken}`;
  }

  if (body) {
    const isSendingJSON =
      typeof headers !== "undefined" &&
      typeof headers["Content-Type"] !== "undefined" &&
      headers["Content-Type"] === "application/json";
    body = isSendingJSON ? JSON.stringify(body) : toFormData(body);
  }

  return fetch(path, {
    mode: "cors",
    ...overrides,
    headers: requestHeaders,
    method,
    body,
  });
}

async function fetchParseAndHandleErrors(
  { method, path, body, options },
  dataAttribute = undefined,
) {
  let response = {};
  let textResponse = "";
  try {
    response = await fetchRequest({ method, path, body, options });
    textResponse = await response.text();
    const jsonResponse = textResponse !== "" ? JSON.parse(textResponse) : "";
    if (!dataAttribute) {
      return { ...jsonResponse, status: response.status };
    }
    return { data: jsonResponse, status: response.status };
  } catch (e) {
    logError({
      client: getClient.client_uuid,
      feature: "utils.http",
      message: `Errors parsing response to ${method} request to ${path}. Response: ${textResponse}. Error: ${e}.`,
      request: {
        method,
        path,
        body,
        options,
      },
      user: {
        id: getUser.user_uuid,
        name: `${getUser.first_name} ${getUser.last_name}`,
      },
    });
    console.error(`Errors parsing response to ${method} request`, {
      error: e,
      response: textResponse,
    });
    return {
      status: response.status,
      message: "Errors with request. We are working to fix this issue.",
    };
  }
}

export const fetchData = async (
  { path, options = {} },
  dataAttribute = undefined,
) => {
  return await fetchParseAndHandleErrors(
    { method: "GET", path, options },
    dataAttribute,
  );
};

export const postData = async ({ path, body = {}, options = {} }) => {
  return await fetchParseAndHandleErrors({
    method: "POST",
    path,
    body,
    options,
  });
};

export const patchData = async ({ path, body = {}, options = {} }) => {
  return await fetchParseAndHandleErrors({
    method: "PATCH",
    path,
    body,
    options,
  });
};

export const deleteData = async ({ path, options = {} }) => {
  return await fetchParseAndHandleErrors({ method: "DELETE", path, options });
};

export const authenticatedJsonPost = async ({ path, body, token }) =>
  await postData({
    path,
    body,
    options: {
      token,
      headers: {
        "Content-Type": "application/json",
      },
    },
  });

export const authenticatedJsonPatch = async ({ path, body, token }) =>
  await patchData({
    path,
    body,
    options: {
      token,
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
